export const deploymentVersion = 'membership-console-membership-usage-20261104';

// Refresh stale documents without interrupting payment or edited forms.
export function installDeploymentRefresh(currentVersion, win = window) {
  let stopped = false, checking = false, dirty = false, reloading = false;
  const reloadKey = 'gptokens:deployment-reload';
  const protectedPage = () => /^\/(?:checkout(?:\/|$)|oauth(?:\/|$)|membership\/(?:plans|checkout-return)(?:\/|$))/.test(win.location.pathname);
  const check = async () => {
    if (stopped || checking || reloading || dirty || protectedPage() || win.document.visibilityState === 'hidden') return;
    checking = true;
    const controller = new AbortController();
    const timeout = win.setTimeout(() => controller.abort(), 5000);
    try {
      const response = await win.fetch('/deployment-version.json', { cache: 'no-store', credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) return;
      const { release } = await response.json();
      if (stopped || dirty || protectedPage() || win.document.visibilityState === 'hidden' || !/^membership-console-[a-zA-Z0-9-]{1,80}$/.test(release)) return;
      if (release === currentVersion) {
        win.sessionStorage.removeItem(reloadKey);
        return;
      }
      const pair = `${currentVersion}:${release}`;
      if (win.sessionStorage.getItem(reloadKey) === pair) return;
      win.sessionStorage.setItem(reloadKey, pair);
      reloading = true;
      win.location.reload();
    } catch {
      // Failed checks must not log out the user or interrupt the page.
    } finally {
      checking = false;
      win.clearTimeout(timeout);
    }
  };
  const edited = () => { dirty = true; };
  win.addEventListener('focus', check);
  win.addEventListener('pageshow', check);
  win.document.addEventListener('visibilitychange', check);
  win.document.addEventListener('input', edited);
  const timer = win.setInterval(check, 60000);
  check();
  return () => {
    stopped = true;
    win.clearInterval(timer);
    win.removeEventListener('focus', check);
    win.removeEventListener('pageshow', check);
    win.document.removeEventListener('visibilitychange', check);
    win.document.removeEventListener('input', edited);
  };
}
